export default __webpack_public_path__ + "static/media/CapaDown.dc5ae67c.svg";